import { render, staticRenderFns } from "./MeatDetail.vue?vue&type=template&id=216c4d72&scoped=true"
import script from "./MeatDetail.vue?vue&type=script&lang=js"
export * from "./MeatDetail.vue?vue&type=script&lang=js"
import style0 from "./MeatDetail.vue?vue&type=style&index=0&id=216c4d72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216c4d72",
  null
  
)

export default component.exports